import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="country-select"
export default class extends Controller {
  connect() {
    this.sortOptions()
  }

  sortOptions() {
    const select = this.element
    if (!select) return

    // Get all child nodes (includes <hr> if it's there)
    const nodes = Array.from(select.childNodes)

    const priorityNodes = []
    const restOptions = []
    let separatorNode = null
    let afterSeparator = false

    nodes.forEach(node => {
      if (node.tagName === "HR") {
        separatorNode = node
        afterSeparator = true
      } else if (node.tagName === "OPTION" && afterSeparator) {
        restOptions.push(node)
      } else {
        priorityNodes.push(node)
      }
    })

    // Sort restOptions by data-country-name
    restOptions.sort((a, b) => {
      const nameA = a.dataset.countryName || ""
      const nameB = b.dataset.countryName || ""
      return nameA.localeCompare(nameB)
    })

    // Rebuild select contents
    select.innerHTML = ""

    priorityNodes.forEach(n => select.appendChild(n))
    if (separatorNode) select.appendChild(separatorNode)
    restOptions.forEach(n => select.appendChild(n))
  }
}
